
<template>
  <card>
    <div class="row">
      <div class="d-flex w-100 align-items-center">
        <label class="ml-4 btn btn-lg btn-danger mb-0" for="file">Dosya Seç</label>
        <input type="file" id="file" v-on:change="uploadZip($event)" style="display:none" />
        <p class="m-0 ml-3 h6">{{file.name}}</p>
        <p class="m-0 ml-3 h6 text-danger" id="percent">{{uploadPercent}} %</p>
      </div>
    </div>
  </card>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";

export default {
  data: function() {
    return {
      file: {},
      uploadPercent: 0
    };
  },
  components: {
    Card
  },

  methods: {
    uploadZip: function(event) {
      this.file = event.target.files[0];
      if (
        !(
          this.file.type === "application/zip" ||
          this.file.type === "application/x-zip-compressed"
        )
      ) {
        this.notifier(
          "top",
          "right",
          "danger",
          "Lütfen zip formatında bir dosya seçiniz"
        );
      } else {
        let data = new FormData();
        data.append("file", this.file);
        let fileName = this.file.name.split(".");
        let extension = "";
        let newName = "";
        fileName.forEach((e, index) => {
          if (index < fileName.length - 1) {
            newName += e;
          }
          if (index == fileName.length - 1) {
            extension += e;
          }
        });
        newName += new Date().getTime();
        let fullName = newName + "." + extension;
        data.append("fileName", fullName);

        this.$http
          .post("/api/files/upload-zip/" + fullName, data, {
            progress(e) {
              if (e.lengthComputable) {
                this.uploadPercent = (e.loaded / e.total) * 100;
                document.getElementById('percent').innerHTML = this.uploadPercent.toFixed(2) + '%';
              }
            }
          })
          .then(
            response => {
              this.notifier(
                "top",
                "right",
                "success",
                "Sonuçlar Başarıyla Yüklendi"
              );
              this.file = {};
              event.target.value = null;
              this.uploadPercent = 0;
            },
            er => {
              this.notifier(
                "top",
                "right",
                "danger",
                "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
              );
              this.uploadPercent = 0;
            }
          );
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {});
  }
};
</script>
<style>
.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: #007bff !important;
}
.nav-pills:focus {
  outline: none;
}
.nav-pills a {
  color: #000;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  color: #fff;
}
.nav-item {
  margin-bottom: 5px;
}
.menu-item:hover {
  cursor: move;
}

.bg-gray {
  background-color: #bdc3c7 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ScoresModules/Index.vue